"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepClone = void 0;
const ramda_1 = require("ramda");
const is_object_not_null_1 = require("../../validation/is-object-not-null/is-object-not-null");
/**
 * Deep clone an object.
 * @public
 *
 * @param obj - The object to clone.
 * @returns The cloned object.
 *
 * @example
 * ```ts
 * const obj = { a: 1, b: { c: 2 } };
 * const result = deepClone(obj);
 * console.log(result);
 * // -> { a: 1, b: { c: 2 } }
 * ```
 */
function deepClone(obj) {
    return (0, ramda_1.cond)([
        [(0, ramda_1.pipe)(is_object_not_null_1.isObjectNotNull, ramda_1.not), ramda_1.identity],
        [Array.isArray, (0, ramda_1.map)(deepClone)],
        [
            ramda_1.T,
            (0, ramda_1.pipe)((0, ramda_1.mergeDeepLeft)({}), (0, ramda_1.mapObjIndexed)(deepClone)),
        ],
    ])(obj);
}
exports.deepClone = deepClone;
//# sourceMappingURL=deep-clone.js.map